import { useEffect } from "react";
export const useEditFocus = (setFocus, isEditing, firstFieldName, delay = 0) => {
    useEffect(() => {
        if (isEditing) {
            const timeoutId = setTimeout(() => {
                setFocus(firstFieldName);
            }, delay);
            return () => clearTimeout(timeoutId);
        }
        return undefined;
    }, [isEditing, setFocus, firstFieldName, delay]);
};
//# sourceMappingURL=useFormFocus.js.map